import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const LessonGroupService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_GROUP, null, wait).then((data) => {
            callback(data);
        });
    },
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.LESSON_GROUP + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },
};